// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_383z6","svgAvatar":"_34lQc","imageAvatar":"_2k-kk"};